<p-card>
  <app-card-title key="project.steps.rfc.invitationPreview" />
  @if (!isStepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
  } @else if (invitationPreviewResource.isLoading()) {
    <app-loading />
  } @else {
    <p-tabs
      appTabsUnsavedReveal
      [value]="activeTabIndex()"
      (valueChange)="onTabChange($event!)"
      scrollable
    >
      <p-tablist>
        <p-tab [value]="0" [appTabStatus]="mailPreviewTabStatus.signal()"
          >{{ 'project.steps.rfc.projectDecision.tab.mailPreview' | transloco }}
        </p-tab>
        <p-tab [value]="1" [appTabStatus]="projectDecisionStatus.signal()"
          >{{ 'project.steps.rfc.projectDecision.tab.decision' | transloco }}
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-card>
          <p-tabpanel [value]="0">
            <app-step-9-2-1-rfc-mail-preview
              [preloadedData]="invitationPreviewResource.value()"
              [stepLocked]="isButtonDisabled()"
              (statusChange)="onMailPreviewStatusChange($event)"
            ></app-step-9-2-1-rfc-mail-preview>
          </p-tabpanel>

          <p-tabpanel [value]="1">
            <app-step-9-2-2-project-decision
              [projectId]="projectId"
              [isCurrentStepLocked]="isCurrentStepLocked()"
              (updateState)="updateStepState($event)"
            ></app-step-9-2-2-project-decision>
          </p-tabpanel>
        </p-card>
      </p-tabpanels>
    </p-tabs>
  }
</p-card>
